module.exports = __webpack_public_path__ + "static/media/SFPRODISPLAYBOLD.644563f4.OTF";